<template>
    <v-expand-x-transition v-if="data">
        <v-row class="zoom-panel">
            <v-col class="step-first-column col-3 zoom-first-col not-favorite">
                <div
                    class="v-flex"
                    :class="bid.favorite ? 'favorite primary white--text' : 'not-favorite black--text'"
                    style="border-radius: 4px"
                >
                    <div style="margin-top: 1px" class="mr-3">
                        <a @click="onClose">
                            <i class="fas fa-arrow-left" :class="bid.favorite ? 'white--text' : 'primary--text'" style="font-size: 15px"></i>
                        </a>
                    </div>
                    <div class="space-between">
                        <span v-if="bid.favorite" ><i class="fas fa-star mr-1"></i>{{ $t("repair.bid.label.favorite") }}</span>
                        <span v-if="!bid.favorite"><i class="far fa-star mr-1"></i></span>

                        <span class="mr-5">{{ $t("repair.bid.name." + bid.bidname) }}</span>
                    </div>
                </div>

                <c-flip-card :top="-21" :color="bid.favorite?'white':'#0a68b8'">
                    <template slot="front">
                        <div class="w-100">
                            <v-row class="no-frame mt-2">
                                <v-col class="no-frame">
                                    <f-read-only-field
                                        label="Bearbeitungsstatus"
                                        :value="bid.status.name"
                                    />
                                </v-col>
                            </v-row>
                            <v-row class="no-frame" v-show="bid.status.id !== 0">
                                <v-col class="no-frame">
                                    <f-read-only-field
                                        label="Ausführendes Unternehmen"
                                        :value="bid.manufacturer.name"
                                    />
                                </v-col>
                            </v-row>
                            <v-row class="no-frame" v-show="bid.status.id !== 0">
                                <v-col class="no-frame">
                                    <f-read-only-field
                                        label="Email Ansprechpartner"
                                        :value="bid.email"
                                    />
                                </v-col>
                            </v-row>
                            <v-row class="no-frame" v-show="bid.status.id !== 0">
                                <v-col class="no-frame mr-2">
                                    <f-read-only-field
                                        :label="$t('repair.bid.label.number')"
                                        :value="bid.number"
                                    />
                               </v-col>
                                <v-col class="no-frame ml-2">
                                    <f-read-only-field
                                        label="Lieferzeit"
                                        :value="bid.deliverytime.name"
                                    />
                                </v-col>
                            </v-row>

                            <inc-calculation-sum
                                v-if          = "bid.calculations"
                                :calculations = "bid.calculations"
                                style         = "margin-top: 39px"
                            />
                        </div>
                    </template>
                    <template slot="back">
                        <div class="w-100">
                            <inc-bid-documents v-if="data" :collection-id="data.id" :bid-id="bid.id"/>
                        </div>
                    </template>
                </c-flip-card>
            </v-col>

            <v-col class="zoom-site-panel v-flex" style="max-width: calc(75% - 12px); flex-wrap: wrap; overflow-y: scroll; flex-direction: row;
    align-content: flex-start; ">
                <inc-bid-calculation
                    v-for     = "(calculation, index) in bid.calculations"
                    :calculation = "calculation"
                    :favorite = "bid.favorite"
                    :status   = "bid.status"
                    :key      = "index"
                    style     = "width: calc(33.33% - 10px); margin: 0 5px 10px;"
                    :form     = "form"
                    :readonly = "readonly"
                />
            </v-col>
        </v-row>
    </v-expand-x-transition>
</template>

<script>

import IncBidCalculation        from "@/modules/inc/steps/components/repair/private/IncBidCaclulation.vue";
import IncBidDocuments   from "@/modules/inc/steps/components/repair/private/IncBidDocuments.vue";
import CFlipCard         from "@/modules/core/components/utils/CFlipCard.vue";
import IncCalculationSum from "@/modules/inc/steps/components/repair/private/IncCalculationSum.vue";
import FReadOnlyField from "@/modules/core/components/utils/FReadOnlyField.vue";

export default {
    name: "IncBidZoom",

    components: {
        FReadOnlyField,
        IncCalculationSum,
        IncBidDocuments,
        CFlipCard,
        IncBidCalculation
    },

    props: {
        bid: {
            required: true,
            type    : Object
        },
        data: {
            required: true,
            type    : Object
        },
        form: {
            required: true,
            type    : Object
        },
        readonly: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    },

    mounted() {
        this.form.validate();
    },

    methods: {
        onClose () {
            this.$emit("close", this.bid.calculations);
        },
    }
}
</script>

<style scoped>

.favorite,
.not-favorite {
    width: 100%;
    height: 30px;
    padding-left: 10px;
    padding-right: 10px;
    font-size: 11pt;
    padding-top: 4px;
}

.not-favorite {
    border-style: solid;
    border-width: 1px;
}

::v-deep .v-menu__content {
    box-shadow: none;
}

.zoom-panel {
    position: fixed;
    width: calc(100% - 105px);
    height: 690px;
    background-color: white;
    z-index: 5;
    padding: 0;
    margin: 0;
    padding-right: 5px;
}

.zoom-site-panel {
    border-style: solid;
    border-width: 0;
    border-color: lightgrey;
    padding: 0;
    border-radius: 5px;
    min-height: 710px;
    max-height: 710px;
    margin-bottom: 0;
}

.zoom-first-col {
    padding: 15px;
    margin-right: 5px;
    min-height: 690px;
    max-height: 690px;
    border-width: 3px;
}

div::-webkit-scrollbar {
    width: 8px !important;
    border-radius: 10px;
}

div::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0 rgba(0, 0, 0, 0.3)!important;
    border-radius: 10px;
}

div::-webkit-scrollbar-thumb {
    background: white;
}

div:hover::-webkit-scrollbar-thumb {
    background: lightgray;
    border-radius: 10px;
}

</style>